export const testManagementRoutes = [
  {
    path: "/admin/test",
    name: "AdminTest",
    component: () => import("./views/TestAdmin.vue"),
  },
];
